import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Mail } from "lucide-react";
import { toast } from "sonner";
import { LogoMark } from "@/components/site/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiErrorDetail } from "@/api";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("d2w_token", data.token);
      toast.success("Welcome back, boss!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#050505] min-h-screen flex items-center justify-center px-5" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md border border-white/10 bg-card p-9"
      >
        <div className="flex flex-col items-center mb-8">
          <LogoMark className="w-12 h-12 text-white" />
          <h1 className="font-display font-semibold uppercase tracking-tight text-2xl mt-4 text-white">Admin Access</h1>
          <p className="text-white/40 text-xs uppercase tracking-[0.25em] mt-1">Deal 2 Wheel Control Room</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
          <div className="space-y-2">
            <Label htmlFor="admin-email" className="text-xs uppercase tracking-widest text-white/50">Email</Label>
            <div className="relative">
              <Mail className="w-4 h-4 text-white/30 absolute left-4 top-1/2 -translate-y-1/2" />
              <Input
                id="admin-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email-input"
                placeholder="admin@deal2wheel.com"
                className="bg-[#0a0a0a] border-white/15 text-white rounded-none h-12 pl-11"
              />
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="admin-password" className="text-xs uppercase tracking-widest text-white/50">Password</Label>
            <div className="relative">
              <Lock className="w-4 h-4 text-white/30 absolute left-4 top-1/2 -translate-y-1/2" />
              <Input
                id="admin-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password-input"
                placeholder="••••••••"
                className="bg-[#0a0a0a] border-white/15 text-white rounded-none h-12 pl-11"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-volt text-black font-semibold uppercase tracking-widest py-4 hover:brightness-110 disabled:opacity-50 transition-[filter] duration-300"
          >
            {loading ? "Checking..." : "Enter Showroom"}
          </button>
        </form>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
